/**
 * Created by adalto on 6/3/14.
 */


Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};
Greenmile.Task.RelatedInfo.Equipment = {

    removeLinkedEquipmentFromList: function (el) {

        var lineItem = el.parentNode.parentNode.parentNode.parentNode;

        if (lineItem.className === 'controls') {
            lineItem = el.parentNode.parentNode;
        }

        var lineItemContainer = lineItem.parentNode;

        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedEquipmentFromData: function (el) {

        var node = el.parentNode.parentNode;
        var nodes = Monet.Session.Task.lastLinkForm.equipments.nodes;
        var ids = Monet.Session.Task.lastLinkForm.equipments.ids;
        var data = Monet.Session.Task.lastLinkForm.equipments.data;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {
            if (nodes[i].id === node.id) {
                index = i;
                break;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            Monet.Session.Task.newTask.equipments.splice(index, 1);
        }

    },

    createEquipmentIdNode: function (data) {

        var divContainer = document.createElement('div');
        var divTitle = document.createElement('div');
        var divDel = document.createElement('div');
        var divDestroy = document.createElement('div');
        var divClear = document.createElement('div');
        var inputStatus = document.createElement('input');
        var inputLinked = document.createElement('input');
        var input = document.createElement('input');
        var linkedTaskWhen = document.createElement('input');

        divContainer.id = "equipment_" + data.equipment.id;
        divContainer.className = "item_lookuplist_equipment_" + data.equipment.id;

        divTitle.className = "title_item_added";
        divTitle.appendChild(document.createTextNode(data.equipment.key));

        divDel.className = "del_item_added";

        divDestroy.className = "table-action-destroylink";
        divDestroy.innerHTML = "&nbsp;";
        divClear.style.clear = "both";

        divDestroy.addEventListener('click', (function (scope, data) {

            return function (e) {

                e.preventDefault();

                const confirmDeleteEquipment = () => {
                    App.Views.Task.showLoadingElement(this);
                    Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                        return function () {

                            App.Views.Task.hideLoad();

                            scope.removeLinkedEquipmentFromList(e.target);
                            scope.removeLinkedEquipmentFromData(e.target, scope);
                            Greenmile.Task.RelatedInfo
                                .removeTitleContainerIfEmptyTo(
                                    Greenmile.Task.RelatedInfo.collections.EQUIPMENTS
                                );
                        };
                    }(e)));
                };

                Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteEquipment);

            };

        }(this, data)));

        linkedTaskWhen.type = 'hidden';
        linkedTaskWhen.id = "taskLinkeds[" + data.equipment.id + "].when";
        linkedTaskWhen.name = "taskLinkeds[" + data.equipment.id + "].when";
        linkedTaskWhen.className = "modelAttribute";
        linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

        input.type = "hidden";
        input.name = "taskLinkeds[" + data.equipment.id + "].equipment.id";
        input.id = "taskLinkeds[" + data.equipment.id + "].equipment.id";
        input.className = "modelAttribute";
        input.value = data.equipment.id;

        inputStatus.type = 'hidden';
        inputStatus.name = 'taskLinkeds[' + data.equipment.id + '].status';
        inputStatus.id = 'taskLinkeds[' + data.equipment.id + '].status';
        inputStatus.className = "modelAttribute";
        inputStatus.value = '';

        inputLinked.type = 'hidden';
        inputLinked.name = 'taskLinkeds[' + data.equipment.id + '].id';
        inputLinked.id = 'taskLinkeds[' + data.equipment.id + '].id';
        inputLinked.className = "modelAttribute";
        inputLinked.value = data.id || '';

        divDel.appendChild(divDestroy);

        divContainer.appendChild(divTitle);
        divContainer.appendChild(divDel);
        divContainer.appendChild(divClear);
        divContainer.appendChild(input);
        divContainer.appendChild(inputStatus);
        divContainer.appendChild(inputLinked);
        divContainer.appendChild(linkedTaskWhen);

        Monet.Session.Task.lastLinkForm.equipments.nodes.push(divContainer);
        Monet.Session.Task.lastLinkForm.equipments.data.push(data);
        Monet.Session.Task.lastLinkForm.equipments.ids.push(input);

    },

    createFullEquipmentInfo: function (data) {

        Monet.Session.Task.lastLinkForm.equipments.nodes = [];
        Monet.Session.Task.lastLinkForm.equipments.data = [];
        Monet.Session.Task.lastLinkForm.equipments.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('equipment')) {
                this.createEquipmentIdNode(data[i]);
            }

        }

    }

};